import isAfter from 'date-fns/isAfter';
import { combineDateParts } from 'utils';

export const sortSlides = slidesById => Object.keys(slidesById).sort((a, b) => {
  const aDate = combineDateParts(slidesById[a]);
  const bDate = combineDateParts(slidesById[b]);

  if (!aDate && !bDate) {
    return 1;
  } else if (aDate && !bDate) {
    return 1;
  } else if (bDate && !aDate) {
    return -1;
  } else {
    return isAfter(aDate, bDate) ? 1 : -1;
  }
});
